import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormAction } from '../../enums';
import { FormInput } from '../../models';

@Component({
  selector: 'app-form-base',
  template: ''
})
export class FormBaseComponent<T> implements OnInit {

  @Input() formInput: FormInput<T> = null;

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<T>();

  isUpdate = false;

  form = this.fb.group({});

  constructor(protected fb: FormBuilder) {
  }

  ngOnInit(): void {

    this.isUpdate = this.formInput.action === FormAction.Update;
    if (this.isUpdate) {
      this.initUpdate();
    }
    else {
      this.initAdd();
    }

    this.setFormLogic();

    // emit
    this.form.valueChanges.subscribe(_ => this.emitFormValueChanges());
    this.form.statusChanges.subscribe(v => this.formStatusChanges.emit(v));
  }

  initAdd() { }

  initUpdate() { }

  setFormLogic() { }

  getValues(): T {
    return {
      ...this.formInput.item,
      ...this.form.value
    };
  }

  emitFormValueChanges() {
    const value = this.getValues();
    this.formValueChanges.emit(value);
  }

}
